import { render } from "./otp2.vue?vue&type=template&id=ed953a74&scoped=true"
import script from "./otp2.vue?vue&type=script&lang=js"
export * from "./otp2.vue?vue&type=script&lang=js"

import "./otp2.vue?vue&type=style&index=0&id=ed953a74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed953a74"]])

export default __exports__